var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTeam = function SvgTeam(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0002 40.0975C34.7612 40.0975 38.6208 36.1663 38.6208 31.317C38.6208 26.4677 34.7612 22.5365 30.0002 22.5365C25.2391 22.5365 21.3795 26.4677 21.3795 31.317C21.3795 36.1663 25.2391 40.0975 30.0002 40.0975Z",
    className: "highlight",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6552 26.0488C46.6632 26.0454 48.6443 26.5199 50.4404 27.4346C52.2364 28.3493 53.7978 29.6788 55 31.3171",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 31.3171C6.20215 29.6788 7.76353 28.3493 9.5596 27.4346C11.3557 26.5199 13.3367 26.0454 15.3448 26.0488",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5861 48C18.7215 45.6316 20.4871 43.6357 22.6819 42.2395C24.8766 40.8434 27.4122 40.1031 29.9999 40.1031C32.5875 40.1031 35.1231 40.8434 37.3179 42.2395C39.5126 43.6357 41.2782 45.6316 42.4136 48",
    className: "highlight",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3447 26.0488C14.0357 26.0501 12.7534 25.672 11.6476 24.9587C10.5417 24.2453 9.65807 23.2261 9.09981 22.0202C8.54154 20.8144 8.33174 19.4716 8.49491 18.1487C8.65809 16.8259 9.1875 15.5777 10.0213 14.5499C10.8551 13.5222 11.9588 12.7574 13.2035 12.3448C14.4482 11.9322 15.7825 11.889 17.0505 12.2201C18.3184 12.5512 19.4677 13.243 20.3639 14.2147C21.2602 15.1863 21.8665 16.3977 22.1119 17.7073",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8877 17.7073C38.1331 16.3977 38.7394 15.1863 39.6357 14.2147C40.5319 13.243 41.6812 12.5512 42.9491 12.2201C44.2171 11.889 45.5514 11.9322 46.7961 12.3448C48.0408 12.7574 49.1445 13.5222 49.9783 14.5499C50.8121 15.5777 51.3415 16.8259 51.5047 18.1487C51.6679 19.4716 51.4581 20.8144 50.8998 22.0202C50.3415 23.2261 49.4579 24.2453 48.352 24.9587C47.2462 25.672 45.9639 26.0501 44.6549 26.0488",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTeam);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/svg-icons/team.svg";